import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import GeocoderGeometry = google.maps.GeocoderGeometry;

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  http = inject(HttpClient);
  postalGeometrySubject = new BehaviorSubject<google.maps.GeocoderGeometry>({} as GeocoderGeometry);
  postalGeometry$: Observable<google.maps.GeocoderGeometry>;

  constructor() {
    this.postalGeometry$ = this.postalGeometrySubject.asObservable();
  }

  public unsetPostalGeometry(): void {
    this.postalGeometrySubject.next({} as GeocoderGeometry);
  }

  lookupPostalGeometry(postal: number): void {
    const url = 'https://maps.googleapis.com/maps/api/geocode/json';
    const addr = '?address=' + postal;
    const key = '&key=' + environment.firebaseConfig.apiKey;

    this.http
      .get<{ results: google.maps.GeocoderResult[]; status: google.maps.GeocoderStatus }>(url + addr + key)
      .subscribe((response: { results: google.maps.GeocoderResult[]; status: google.maps.GeocoderStatus }) => {
        const postalGeometry: google.maps.GeocoderGeometry = response['results'][0].geometry;
        this.postalGeometrySubject.next(postalGeometry);
      });
  }
}
